import { Stack } from '@mantine/core'
import React from 'react'

export default function ReportWrapper({ children }: { children: React.ReactNode }) {
  return <Stack className={'p-3'}>{children}</Stack>
}
